// Login.js
import React, { useState } from "react";
import { loginUser } from "../services/apiService";
import { useNavigate } from "react-router-dom";

const Login = () => {
    const [form, setForm] = useState({ username: "", password: "" });
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const res = await loginUser(form.username, form.password);
        if (res.success) {
            navigate("/"); // redirect after login
        } else {
            setError(res.error.message || "Login failed");
        }
    };

    return (
        <div className="max-w-md mx-auto mt-20 text-white">
            <h2 className="text-2xl font-bold mb-4">Login</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                {["username", "password"].map((field) => (
                    <input
                        key={field}
                        type={field === "password" ? "password" : "text"}
                        name={field}
                        placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
                        className="w-full p-2 bg-gray-800 border border-gray-600 rounded"
                        value={form[field]}
                        onChange={handleChange}
                        required
                    />
                ))}
                {error && <p className="text-red-400">{error}</p>}
                <button className="w-full bg-cyan-500 hover:bg-cyan-600 p-2 rounded text-white font-semibold">
                    Login
                </button>
            </form>
        </div>
    );
};

export default Login;
